import React from 'react';

const Button = ({
  children,
  variant = 'primary',
  type = 'button',
  onClick,
  disabled = false,
  loading = false,
  className = '',
  icon: Icon,
  ...props
}) => {
  const variants = {
    primary: 'bg-astra-primary-500 text-white hover:bg-astra-primary-600',
    secondary: 'bg-gray-200 text-gray-800 hover:bg-gray-300',
    danger: 'bg-red-500 text-white hover:bg-red-600',
    ghost: 'bg-transparent text-astra-secondary-500 hover:bg-gray-100',
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`
        px-4 py-2 rounded-lg font-semibold
        focus:outline-none focus:ring-2 focus:ring-astra-primary-500 focus:ring-offset-2
        transition-all duration-200
        disabled:opacity-50 disabled:cursor-not-allowed
        shadow-md hover:shadow-lg
        ${variants[variant]}
        ${className}
      `}
      {...props}
    >
      <span className="flex items-center justify-center gap-2">
        {loading && (
          <div className="h-4 w-4 inline-block animate-spin rounded-full border-2 border-current border-t-transparent"></div>
        )}
        {Icon && <Icon className="h-4 w-4" />}
        {children}
      </span>
    </button>
  );
};

export default Button;
